import {
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import * as _ from "lodash";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { TransactionReportComponent } from "src/app/dashboard/report/transaction-report/transaction-report.component";
import { SubSink } from "subsink";
import { SharedDataService } from "../../shared/sharedData.service";
import { LookUpService } from "../../shared/services/lookup.service";
import { NbcFileDownloadComponent } from "../../shared/component/nbc-file-download/nbc-file-download.component";

@Component({
    selector: "app-report-layout",
    templateUrl: "./report-layout.component.html",
    standalone: false
})
export class ReportLayoutComponent implements OnInit, OnDestroy {
    constructor(
        private _modalService: BsModalService,
        private _lookupService: LookUpService,
        private _sharedDataService: SharedDataService,
        private log: NbcLoggerService
    ) {}

    bsModalRef?: BsModalRef;
    private subs = new SubSink();
    selectedBusinessUnit: any;
    selectedBuAccess: any;
    buAccess: any;
    businessUnitId: any;
    showAlertMessage: any;
    @ViewChild(NbcFileDownloadComponent) child;
    isDownload = false;
    showOnboardingReportAlert = false;
    isAccordionOpen: boolean = true;

    reports: any = [
        {
            title: "General Reports",
            needPermission: true,
            count: 2,
            items: [
                {
                    name: "Pending Onboarding Report",
                    //key: 'PendingOnboardingReport.Export',
                    isExport: "true",
                    isNotCustomize: "false",
                    //hasReportAccess: true
                },
                {
                    name: "Transaction Summary Report",
                    //key: 'TransactionSummaryReport.Export',
                    isExport: "true",
                    isNotCustomize: "false",
                    //hasReportAccess: true
                },
            ],
        },
    ];

    toggleAccordion()
    {
        this.isAccordionOpen = !this.isAccordionOpen;
    }
    customizeReportModal(reportName) {
        switch (reportName) {
            case "Transaction Summary Report":
                {
                    const initialState: any = {
                        controller: "TransactionReportComponent",
                        hideConfirm: false,
                        reportName: reportName,
                    };
                    const modalOptions = {
                        animated: true,
                        keyboard: false,
                        backdrop: true,
                        ignoreBackdropClick: true,
                        initialState: initialState,
                    };
                    this.bsModalRef = this._modalService.show(
                        TransactionReportComponent,
                        modalOptions
                    );
                }
                break;
            case "Pending Onboarding Report":
                {
                    this.isDownload = true;
                    this.subs.sink = this._lookupService
                        .pendingOnboardingReport(this.businessUnitId)
                        .subscribe({
                            next: (data) => {
                                if (data == null) {
                                    this.showAlertMessage = true;
                                    this.showOnboardingReportAlert = true;
                                    this.log.clearAlert();
                                    this.log.showError(
                                        "There are no data points to export for this report at the moment."
                                    );
                                } else {
                                    this.showOnboardingReportAlert = false;
                                    //this.crewRateReport = this.getCriteriaData;
                                    const fileName =
                                        "Pending Onboarding Report";
                                    const d = moment(new Date()).format(
                                        "MM-DD-yyyy"
                                    );
                                    this.showAlertMessage = false;

                                    this.child.fileName = fileName + d;
                                    this.child.fileType = "excel";
                                    this.child.data = data;
                                    this.child.download();
                                }
                            },
                            error: (data) => {
                                this.showAlertMessage = true;
                                this.log.showError("Error Occurred");
                            },
                        });
                }
                break;
        }
    }

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data;
        this.businessUnitId = this.selectedBusinessUnit.id;
    }

    buAccessSelected(data: any) {
        this.selectedBuAccess = data;
    }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._sharedDataService
            .getBuAccess()
            .subscribe(
                (access) => (this.buAccess = this.buAccessSelected(access))
            );
    }

    ngOnInit() {
        this.subscribeEventHandlers();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
